export enum UserType {
  CLIENT = 'client',
  OFFICIAL = 'official',
  PROVIDER = 'provider',
  SUPERADMIN = 'super_admin',
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ALL = 'all',
}
